import React from 'react';
import { MapPin, Maximize, Building2, Building, Layers, BedDouble, HardHat, FileCheck } from 'lucide-react';
import { overview, projectInfo } from '../data/mock';

const iconMap = {
  MapPin,
  Maximize,
  Building2,
  Building,
  Layers,
  BedDouble,
  HardHat,
  FileCheck
};

const OverviewSection = () => {
  return (
    <section id="overview" className="py-16 sm:py-24 bg-gradient-to-b from-[#0a1628] to-[#0d1f35]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span className="text-[#c9a961] text-xs sm:text-sm font-semibold tracking-widest uppercase">Discover</span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mt-2 sm:mt-3 mb-4 sm:mb-6">Project Overview</h2>
          <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-transparent via-[#c9a961] to-transparent mx-auto" />
        </div>

        {/* Overview Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6">
          {overview.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div
                key={index}
                className="group relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl sm:rounded-2xl p-4 sm:p-6 text-center hover:bg-white/10 hover:border-[#c9a961]/30 transition-all duration-500"
              >
                <div className="relative z-10">
                  <div className="w-10 h-10 sm:w-14 sm:h-14 mx-auto mb-2 sm:mb-4 bg-gradient-to-br from-[#c9a961]/20 to-[#c9a961]/5 rounded-lg sm:rounded-xl flex items-center justify-center">
                    {IconComponent && <IconComponent className="w-5 h-5 sm:w-7 sm:h-7 text-[#c9a961]" />}
                  </div>
                  <h3 className="text-white font-bold text-sm sm:text-lg mb-1 truncate" title={item.value}>{item.value}</h3>
                  <p className="text-white/60 text-xs sm:text-sm">{item.label}</p>
                </div>
              </div>
            );
          })}
        </div>
        
        {/* Full RERA Number */}
        <div className="mt-6 sm:mt-8 text-center">
          <p className="text-white/40 text-xs sm:text-sm">
            <span className="text-white/60">RERA ID:</span> {projectInfo.reraId}
          </p>
        </div>
      </div>
    </section>
  );
};

export default OverviewSection;
